import { Skeleton } from '@/new/components/shadcn/skeleton';

export function FactsTableLoader() {
  return (
    <div className="mx-5 w-full rounded-md">
      {Array.from({ length: 12 }).map((_, index) => (
        <div key={index} className="flex w-full items-center gap-2.5 border-b px-3 py-6 last:border-b-0">
          <div className="flex-1 space-y-3">
            <div className="flex justify-between">
              <Skeleton className="h-3 w-32" />
              <Skeleton className="h-3 w-24" />
            </div>
            <Skeleton className="h-3 w-3/4" />
          </div>
        </div>
      ))}
    </div>
  );
}
